//WithPrivateRoute.js
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const WithPrivateRoute = ({ children }) => {
  const { currentUser, userObjectId, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!currentUser || !userObjectId) {
    // User not authenticated or not in database
    return <Navigate to="/login" />;
  }

  return children;
};

export default WithPrivateRoute;